import permissions from '../features/Share/config/permissions.js';

/**
 * Whether this facility session may ask the API for an A-MIS token. The token is only used by
 * A-MIS facilities, and the endpoint (GET api/AMIS/getToken) answers 403 without
 * `Inspection Tags.View`, so asking anyway only shows the user an error they cannot act on.
 * @param {{isAMIS?: boolean, isInspectionsOn?: boolean}} settings the facility's forge settings
 * @param {(permission: string) => boolean} has the permission check (`$has`)
 */
export function canRequestAmisToken(settings, has) {
  return Boolean(settings?.isInspectionsOn && settings?.isAMIS && has(permissions.InspectionTags.View));
}
